export default __webpack_public_path__ + "static/media/SOLAR.f8de39fd.png";